import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import * as Yup from "yup";

dayjs.extend(utc);

// The connections API validates birth_date as `date_format:d/m/Y`, so the form
// must send a full DD/MM/YYYY (a bare DD/MM used to pass here and 422 there).
const DMY = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const BIRTH_DATE_FORMAT_MESSAGE =
  "Please enter birth date in the format DD/MM/YYYY";
export const BIRTH_DATE_INVALID_MESSAGE = "Please enter a valid birth date.";

/**
 * Turn whatever the API returns for birth_date into the DD/MM/YYYY the form
 * expects. The API sends a date cast, e.g. "1990-05-13T00:00:00.000000Z";
 * it is read as UTC so the day never shifts in a timezone behind UTC.
 * Empty -> "", already DD/MM/YYYY -> unchanged, unparseable -> unchanged
 * (so the validation message shows instead of the value silently vanishing).
 */
export const toBirthDateInput = (value) => {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value === "string" && DMY.test(value)) return value;

  const parsed = dayjs.utc(value);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : value;
};

/** True for a real calendar date in DD/MM/YYYY that is not in the future. */
export const isValidBirthDate = (value) => {
  const match = DMY.exec(value || "");
  if (!match) return false;

  const [, day, month, year] = match;
  const parsed = dayjs.utc(`${year}-${month}-${day}`);
  // Round-trip catches dates the parser rolls over, e.g. 31/02 -> 03/03.
  if (!parsed.isValid() || parsed.format("DD/MM/YYYY") !== value) return false;

  return `${year}-${month}-${day}` <= dayjs().format("YYYY-MM-DD");
};

// Optional field: empty passes; anything typed must be a full, real DD/MM/YYYY.
export const birthDateRule = Yup.string()
  .nullable()
  .matches(DMY, {
    message: BIRTH_DATE_FORMAT_MESSAGE,
    excludeEmptyString: true,
  })
  .test(
    "birth-date",
    BIRTH_DATE_INVALID_MESSAGE,
    (value) => !value || !DMY.test(value) || isValidBirthDate(value)
  );
